var $1648ec00941567f3$exports = {};
$1648ec00941567f3$exports = {
  "ascending": "\u5347\u5E8F",
  "ascendingSort": function ascendingSort(args) {
    return "\u6309\u5217 ".concat(args.columnName, " \u5347\u5E8F\u6392\u5E8F");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " \u50CF\u7D20");
  },
  "descending": "\u964D\u5E8F",
  "descendingSort": function descendingSort(args) {
    return "\u6309\u5217 ".concat(args.columnName, " \u964D\u5E8F\u6392\u5E8F");
  },
  "resizerDescription": "\u6309\u201C\u8F93\u5165\u201D\u952E\u5F00\u59CB\u8C03\u6574\u5927\u5C0F\u3002",
  "select": "\u9009\u62E9",
  "selectAll": "\u5168\u9009",
  "sortable": "\u53EF\u6392\u5E8F\u7684\u5217"
};
export { $1648ec00941567f3$exports as default };